export const PRESET_COLORS: Record<string, { label: string; value: string }> = {
  red: { label: 'Red', value: '#ff0000' },
  green: { label: 'Green', value: '#00aa00' },
  blue: { label: 'Blue', value: '#0066ff' },
  yellow: { label: 'Yellow', value: '#ffcc00' }
};

export type PresetColorKey = keyof typeof PRESET_COLORS;

export type ColorConfig =
  | { mode: 'preset'; presetKey: PresetColorKey }
  | { mode: 'custom'; r: number; g: number; b: number };

export type PdfDayCellLine = { text: string; color?: string };

export type PdfDayCell = {
  key: string;
  dayNumber: number;
  inMonth: boolean;
  lines: PdfDayCellLine[];
};

export type PdfMonthModel = {
  monthLabel: string;
  weekRows: PdfDayCell[][];
};

export type PdfMultiMonthModel = {
  months: PdfMonthModel[];
};

export type SubstituteState = {
  assignmentId: string;
  replaceUserId: string;
  substituteUserId: string;
  startDate: string;
  endDate: string;
};

export type ManualAssignmentState = {
  assignees: string[];
  startDate: string;
  endDate: string;
  notes: string;
  allowOverlap: boolean;
};

export type RotationState = {
  pool: string[];
  startDate: string;
  durationDays: number;
  periods: number;
  throughYearEnd: boolean;
  assigneesPerRotation: number;
  allowOverlap: boolean;
};

export type ScheduleFilters = {
  assigneeIds: string[];
  start: string;
  end: string;
};
